export interface EnvConfig {
  webapiV2: {
    URL: string;
  };
}
const dev: EnvConfig = {
  webapiV2: {
    URL: 'https://portal-api.dev-simulation.cloud',
    //URL: "http://localhost:5000",
  },
};

const prod: EnvConfig = {
  webapiV2: {
    URL: 'https://portal-api.simulation.cloud',
  },
};
const uat: EnvConfig = {
  webapiV2: {
    URL: 'https://portal-api.uat-simulation.cloud',
    //URL: "http://localhost:5000",
  },
};
const pentest: EnvConfig = {
  ...uat,
  webapiV2: {
    URL: 'https://pentest-portal-api.uat-simulation.cloud',
    //URL: "http://localhost:5000",
  },
};
const cn: EnvConfig = {
  webapiV2: {
    URL: 'https://portal-api.fangzhen.cloud',
  },
};
const itar: EnvConfig = {
  webapiV2: {
    URL: 'https://portal-api.itar-simulation.cloud',
  },
};
export function getConfig(): EnvConfig {
  const BUILD_ENV = process.env.REACT_APP_BUILD_ENV;
  if (BUILD_ENV === 'prod') {
    return prod;
  } else if (BUILD_ENV === 'uat') {
    return uat;
  } else if (BUILD_ENV === 'pentest') {
    return pentest;
  } else if (BUILD_ENV === 'cn') {
    return cn;
  } else if (BUILD_ENV === 'itar') {
    return itar;
  }
  return dev;
}

export default getConfig();
